export default "__VITE_ASSET__D542bY_6__"